// Subscription bridge.
//
// When Supabase is configured + the user is signed in, returns their
// real row from the existing `subscriptions` table (managed by the
// billing-webhook Edge Function). Otherwise reports Free so the
// renderer's tier-gated UI keeps working in the signed-out / fixture
// fallback path.

const FREE = { tier: 'free', status: 'active', periodEnd: null };

export function buildSubscriptionHandlers({ supabase } = {}) {
  async function fetchTier() {
    if (!supabase) return FREE;
    const { data: sess } = await supabase.auth.getSession();
    const userId = sess?.session?.user?.id;
    if (!userId) return FREE;
    const { data, error } = await supabase
      .from('subscriptions')
      .select('tier, status, current_period_end')
      .eq('user_id', userId)
      .maybeSingle();
    if (error || !data) return FREE;
    return {
      tier: data.tier || 'free',
      status: data.status || 'active',
      periodEnd: data.current_period_end || null,
    };
  }

  // Match the Electron `subscription:get` contract: the renderer
  // reads `result.subscription.tier` (src/main/main.js:1134).
  return {
    async subscriptionGet() {
      try {
        const subscription = await fetchTier();
        return { ok: true, subscription };
      } catch (err) {
        console.error('[bridge.subscription.get]', err);
        return { ok: true, subscription: FREE };
      }
    },
    async subscriptionRefresh() {
      try {
        const subscription = await fetchTier();
        return { ok: true, subscription };
      } catch (err) {
        return { ok: false, error: err.message };
      }
    },
  };
}
